export const TermsAndConditions = () => {
  return (
    <main className="mx-auto max-w-4xl pt-20">
      <div className="mb-6 text-4xl">Mozio Parking T&C</div>

      <ol type="1">
        <li className="mb-4 text-lg">
          1. Definitions
          <p className="mb-4 text-sm">
            Parking Facility: A designated area for parking vehicles, comprising
            parking spaces and specified zones for vehicle parking.
          </p>
          <p className="mb-4 text-sm">
            Parking Fee: The amount that the User is obligated to pay for
            utilizing the Parking Facility.
          </p>
          <p className="mb-4 text-sm">
            Parking Management System (PMS): A comprehensive system,
            encompassing both hardware and software, utilized for controlling
            entry, facilitating payment transactions, managing exit procedures,
            and providing managerial information pertaining to the Parking
            Facility.
          </p>
          <p className="mb-4 text-sm">
            Parking Period: The timeframe pre-determined by the User in their
            reserved parking booking, during which the vehicle is intended to be
            parked.
          </p>
          <p className="mb-4 text-sm">
            Proof of Parking: Documentation such as a car park ticket, parking
            pass, or any other credential specified by Mozio, serving as
            evidence for gaining access to the Parking Facility and displaying
            the entry time.
          </p>
          <p className="mb-4 text-sm">
            Mozio: The Mozio Group located at 9450 SW Gemini Dr, Beaverton, OR,
            97008-7105, US, with the email address: info@mozio.com.
          </p>
          <p className="mb-4 text-sm">
            User: The individual who owns, holds the vehicle registration
            certificate, uses, or is a passenger in a vehicle and intends to
            bring or has brought the vehicle into the Parking Facility.
          </p>
          <p className="mb-4 text-sm">
            Meet & Greet: The parking service provided by Mozio, involving the
            acceptance, custody, and return of vehicles to the User.
          </p>
        </li>

        <li className="mb-4 text-lg">
          2. Eligibility
          <ol type="1">
            <li className="mb-4 text-sm">
              2.1. You must be at least eighteen (18) years old to use the
              Service. By agreeing to the Terms, you represent and warrant to
              us: (i) that you are at least eighteen (18) years old (ii) that
              you have not previously been suspended or removed from the Service
              and (iii) that your registration and your use of the Service is in
              compliance with any and all applicable laws and regulations. If
              you are using the Service on behalf of an entity, organization, or
              company (collectively &quot;Subscribing Organization&quot;), you
              are an authorized representative of that Subscribing Organization
              with the authority to bind such organization to these Terms; and
              agree to be bound by these Terms on behalf of such Subscribing
              Organization. In such a case, “you” in these Terms refers to your
              Subscribing Organization, and any individual authorized to use the
              Service on behalf of the Subscribing Organization, including you.
            </li>
          </ol>
        </li>

        <li className="mb-4 text-lg">
          2. Applicability of terms and conditions
          <ol type="1">
            <li className="mb-4 text-sm">
              2.1. Entry to the Parking Facilities is exclusively allowed in
              adherence to these terms and conditions, integral components of
              every Parking Agreement established between the User and Mozio.
            </li>
            <li className="mb-4 text-sm">
              2.2. When you make a parking reservation, you are entering into an
              agreement with Mozio for the parking service (Parking Agreement).
            </li>
            <li className="mb-4 text-sm">
              2.3. In cases of disagreements concerning the utilization of the
              Parking Facility, the presence of the User (or their vehicle)
              within the Parking Facility, or the registration in the Parking
              Management System (PMS), the determining factor shall be
              considered.
            </li>
          </ol>
        </li>

        <li className="mb-4 text-lg">
          3. Reservation
          <ol type="1">
            <li className="mb-4 text-sm">
              3.1. To reserve parking, a User must complete the booking form for
              the desired parking product on Mozio&apos;s website at the
              specified rate. The User is authorized to park at the designated
              Parking Facility mentioned in the reservation and not at any other
              location.
            </li>
            <li className="mb-4 text-sm">
              3.2. The user will be informed of the precise requirements
              applicable to the reserved vehicle prior to confirming the
              reservation. It is imperative for the user to acknowledge that
              reservations are made with explicit reference to the designated
              vehicle, and only vehicles meeting the stipulated requirements
              will be granted access to the Parking Facility.
            </li>
            <li className="mb-4 text-sm">
              3.2. Availability is a factor in reserved parking bookings.
            </li>
            <li className="mb-4 text-sm">
              3.3. Once the reservation or booking is finalized, Mozio will
              confirm it through an email sent to the address provided by the
              User. This confirmation serves as evidence of the Parking
              Agreement&apos;s existence and details. Amendments to the
              reservation can be made by phone, email, or on the website through
              the &quot;changes&quot; section. The User can cancel the
              reservation free of charge, adhering to the cancellation policy
              stated in the reservation confirmation, before the Parking Period
              by sending an email referencing the reservation number to
              info@mozio.com. If the User surpasses the cancellation policy, the
              Parking Fee already paid will not be refunded
            </li>
            <li className="mb-4 text-sm">
              3.4. The User is permitted to enter the Parking Facility at the
              time specified in the reservation confirmation and must exit the
              facility at the time indicated in the same confirmation.
            </li>
          </ol>
        </li>

        <li className="mb-4 text-lg">
          4. Parking Facility and access
          <ol type="1">
            <li className="mb-4 text-sm">
              4.1. Access to the Parking Facility is granted solely with a valid
              Proof of Parking for the User, motor vehicle, or individual.{" "}
            </li>
            <li className="mb-4 text-sm">
              4.2. Entry and exit from the Parking Facility are restricted to
              the specified opening hours indicated in the reservation
              confirmation.{" "}
            </li>
            <li className="mb-4 text-sm">
              4.3. In the event the key of a motor vehicle is surrendered at the
              Parking Facility, the facility provider retains the authority to
              relocate the vehicle if deemed necessary.
            </li>
            <li className="mb-4 text-sm">
              4.4. The Parking Facility operator holds the right to move
              vehicles and/or individuals within the facility or remove, or
              facilitate the removal of, any vehicle if such action is deemed
              necessary. The decision to relocate or remove persons and/or
              vehicles will be exercised with the utmost consideration for
              reasonableness and due care, and the condition of a vehicle may
              serve as grounds for removal without incurring liability on the
              part of Mozio.
            </li>
            <li className="mb-4 text-sm">
              4.5. In the event of a delayed return exceeding the booked
              duration, kindly note that the difference in parking fees will be
              incurred upon your return. This additional amount should be
              settled directly with the car park at their prevailing standard
              daily rate. Please be advised that no refunds will be provided for
              any unused portion of your booked stay
            </li>
            <li className="mb-4 text-sm">
              4.5. Mozio reserves the right to remove vehicles that have been
              parked in violation of the applicable regulations at any time,
              with the associated costs and risks borne by the User. If
              necessary, such vehicles may be relocated outside the Parking
              Facility.{" "}
            </li>
            <li className="mb-4 text-sm">
              4.6. Please be advised to refrain from leaving any valuables
              unattended in your vehicle, as neither we nor the car park can
              accept liability for any ensuing losses. Parking is undertaken
              entirely at the vehicle owner&apos;s risk. In the improbable event
              necessitating a claim for loss or damage, it is mandatory to
              promptly notify the car park at the time of collection and obtain
              written confirmation. Regrettably, claims cannot be entertained
              once the vehicle has departed from the site. The car park assumes
              liability solely for proven acts of negligence on their part.
            </li>
            <li className="mb-4 text-sm">
              4.7. We kindly request that valuables not be left in the vehicle.
              It is strongly advised to exercise caution in this regard. Please
              note that all vehicles and their contents are left at the
              owner&apos;s risk. Your cooperation in safeguarding your
              belongings is greatly appreciated.{" "}
            </li>
            <li className="mb-4 text-sm">
              4.8. The vehicle owner bears the responsibility of ensuring the
              vehicle&apos;s roadworthiness, possession of a valid circulation
              certificate, and up-to-date taxation until the return date.
              Failure to meet these criteria may result in the forfeiture of
              your booking. Please be aware that the car park cannot assume
              responsibility for mechanical, structural, or electrical failures
              of any part of your vehicle, encompassing windscreens, glass,
              tires, and notably alloy wheels, irrespective of the cause. This
              list is not exhaustive but serves as a guideline.
            </li>
          </ol>
        </li>

        <li className="mb-4 text-lg">
          5. Instructions for use
          <ol type="1">
            <li className="mb-4 text-sm">
              5.1. The User assumes responsibility for accessing and using the
              Parking Facility, exercising caution at all times, particularly
              regarding the facility&apos;s height outside designated driving
              lanes.
            </li>
            <li className="mb-4 text-sm">
              5.2. Adherence to traffic signs and driving directions is
              imperative for the User.
            </li>
            <li className="mb-4 text-sm">
              5.3. The maximum speed permitted within the Parking Facility is 5
              kilometers per hour.
            </li>
            <li className="mb-4 text-sm">
              5.4. While within the Parking Facility, the User must comply with
              local traffic road regulations.
            </li>
            <li className="mb-4 text-sm">
              <p className="mb-4">
                5.5. The following actions are strictly prohibited:{" "}
              </p>
              <ol type="a">
                <li className="mb-4 text-sm">
                  a. Utilizing the Parking Facility for purposes other than
                  vehicle parking.{" "}
                </li>
                <li className="mb-4 text-sm">
                  b. Offering, distributing, selling, or renting goods or
                  services within the Parking Facility.{" "}
                </li>
                <li className="mb-4 text-sm">
                  c. Advertising within or on the Parking Facility.{" "}
                </li>
                <li className="mb-4 text-sm">
                  d. Smoking or creating an open fire within the Parking
                  Facility.{" "}
                </li>
                <li className="mb-4 text-sm">
                  e. Prolonged stays in the motor vehicle beyond what is
                  necessary for parking. After parking, car lights and the motor
                  must be turned off, and all individuals must exit the Parking
                  Facility.{" "}
                </li>
                <li className="mb-4 text-sm">
                  f. Conducting repairs or other vehicle-related activities
                  without Quick Parking&apos;s consent.{" "}
                </li>
                <li className="mb-4 text-sm">
                  g. Leaving waste in the Parking Facilities, except for small
                  items, which should be disposed of in the designated bins.
                </li>
              </ol>
            </li>
            <li className="mb-4 text-sm">
              5.6. The User is obligated to ensure that traffic in and around
              the Parking Facility is not obstructed, and safety is maintained.
              The vehicle&apos;s engine should only be in operation as necessary
              for entering or exiting the Parking Facility.
            </li>
          </ol>
        </li>

        <li className="mb-4 text-lg">
          6. Meet & Greet.
          <ol type="1">
            <li className="mb-4 text-sm">
              6.1 Upon submission of the vehicle and key to the Parking Facility
              personnel, the User is required to affix their signature to a
              provided receipt. Through this formal endorsement, the User
              expressly grants custodial authority of the vehicle and its
              corresponding key to the Parking Facility Operator, as outlined
              within the terms herein.
            </li>
            <li className="mb-4 text-sm">
              6.2 The return of the vehicle and key to the User is contingent
              upon the presentation of a copy of the Receipt. Additionally, as
              per the Parking Facility Operator&apos;s request, we kindly
              request the User&apos;s cooperation in providing a valid identity
              document.
            </li>
            <li className="mb-4 text-sm">
              6.3 In the event of changes to your return flight schedule, a User
              shall submit an amended request for vehicle readiness.
            </li>
            <li className="mb-4 text-sm">
              6.4. The User bears the responsibility to ensure the deactivation
              of all electronic equipment. The User expressly grants consent to
              the Parking Facility Operator&apos;s employees for the limited use
              of said equipment as required for the relocation of the vehicle.
              Additionally, the User agrees to any necessary modifications made
              by the employees to ensure the safe operation of the vehicle. Such
              cooperation is fundamental for the secure handling and operation
              of the User&apos;s vehicle within the parking facility.
            </li>
          </ol>
        </li>

        <li className="mb-4 text-lg">
          7. Prohibited Conduct. BY USING THE SERVICE YOU AGREE NOT TO:
          <ol type="1">
            <li className="mb-4 text-sm">
              7.1 rent, lease, loan, sell, resell, sublicense, distribute or
              otherwise transfer the licenses granted herein or any Materials
              (as defined below);
            </li>
            <li className="mb-4 text-sm">
              7.2 post, upload, or distribute any defamatory, libelous, or
              inaccurate User Content or other content;
            </li>
            <li className="mb-4 text-sm">
              7.3 post, upload, or distribute any User Content or other content
              that is unlawful or that a reasonable person could deem to be
              objectionable, profane, offensive, indecent, pornographic,
              harassing, threatening, embarrassing, distressing, vulgar,
              hateful, racially or ethnically offensive, or otherwise
              inappropriate;
            </li>
            <li className="mb-4 text-sm">
              7.4 impersonate any person or entity, falsely claim an affiliation
              with any person or entity, or access the Service accounts of
              others without permission, forge another person’s digital
              signature, misrepresent the source, identity, or content of
              information transmitted via the Service, or perform any other
              similar fraudulent activity;
            </li>
            <li className="mb-4 text-sm">
              7.5 delete the copyright or other proprietary rights on the
              Service or any User Content;
            </li>
            <li className="mb-4 text-sm">
              7.6 make unsolicited offers, advertisements, proposals, or send
              junk mail or spam to other users of the Service. This includes,
              but is not limited to, unsolicited advertising, promotional
              materials, or other solicitation material, bulk mailing of
              commercial advertising, chain mail, informational announcements,
              charity requests, and petitions for signatures;
            </li>
            <li className="mb-4 text-sm">
              7.7 use the Service for any illegal purpose, or in violation of
              any local, state, national, or international law, including,
              without limitation, laws governing intellectual property and other
              proprietary rights, and data protection and privacy, or the
              collection, storage, transmission, or access of educational
              records;
            </li>
            <li className="mb-4 text-sm">
              7.8 defame, harass, abuse, threaten or defraud users of the
              Service, or collect, or attempt to collect, personal information
              about users or third parties without their consent,
            </li>
            <li className="mb-4 text-sm">
              7.9 use the Service for any commercial purpose other than the
              internal business purposes of maintaining and administering school
              records without our consent;
            </li>
            <li className="mb-4 text-sm">
              7.10 remove, circumvent, disable, damage or otherwise interfere
              with security-related features of the Service or User Content,
              features that prevent or restrict use or copying of any content
              accessible through the Service, or features that enforce
              limitations on the use of the Service or User Content;
            </li>
            <li className="mb-4 text-sm">
              7.11 reverse engineer, decompile, disassemble or otherwise attempt
              to discover the source code of the Service or any part thereof
              (including any App), except and only to the extent that such
              activity is expressly permitted by applicable law notwithstanding
              this limitation;
            </li>
            <li className="mb-4 text-sm">
              7.12 modify, adapt, translate or create derivative works based
              upon the Service or any part thereof, except and only to the
              extent the foregoing restriction is expressly prohibited by
              applicable law; or
            </li>
            <li className="mb-4 text-sm">
              7.13 intentionally interfere with or damage operation of the
              Service or any user’s enjoyment of it, by any means, including
              uploading or otherwise disseminating viruses, adware, spyware,
              worms, or other malicious code.
            </li>
          </ol>
        </li>

        <li className="mb-4 text-lg">
          8. Termination of Use; Discontinuation and Modification of the
          Service.
          <p className="mb-4 text-sm">
            If you violate any of the Terms, your permission to use the Service
            will automatically terminate. You also agree that we may, at any
            time and without notice to you, suspend or revoke your access to and
            use of the Service, and any accounts you may have in connection with
            the Service including: (i) where we determine in our sole discretion
            that such action is reasonable in order to comply with legal
            requirements or to protect the rights or interests of Mozio or any
            third party; or (ii) in connection with any general discontinuation
            of the Service. We also reserve the right to modify the Service at
            any time without notice to you. We will have no liability whatsoever
            on account of any change to the Service or any suspension or
            revocation of your access to or use of the Service, provided that if
            we terminate your access to the Service other than for your breach
            of these Terms, you may be entitled to have your Rewards
            distributed, as described in the Terms. You may terminate your
            account at any time by contacting customer service at
            info@mozio.com. If you terminate your account, you will remain
            obligated to pay all outstanding fees and charges, if any, relating
            to your use of the Service incurred before termination.
          </p>
        </li>

        <li className="mb-4 text-lg">
          9. Ownership; Proprietary Rights.
          <p className="mb-4 text-sm">
            The Service is owned and operated by Mozio. The visual interfaces,
            graphics, design, compilation, information, computer code (including
            source code or object code), products, software, services, and all
            other elements of the Service provided by Mozio (the “Materials”)
            are protected by United States copyright, trade dress, and trademark
            laws, international conventions, and all other relevant intellectual
            property and proprietary rights, and applicable laws. Except for any
            User Content that is provided and owned by users of the Service, all
            Materials contained in the Service are the property of Mozio or its
            subsidiaries or affiliated companies and/or third-party licensors.
            All trademarks, service marks, and trade names are proprietary to
            Mozio or its affiliates and/or third-party licensors. Except as
            expressly authorized by Mozio, you agree not to sell, license,
            distribute, copy, modify, publicly perform or display, transmit,
            publish, edit, adapt, create derivative works from, or otherwise
            make unauthorized use of the Materials. Mozio reserves all rights to
            the Materials not expressly granted in the Terms.
          </p>
        </li>

        <li className="mb-4 text-lg">
          10. Indemnity.
          <p className="mb-4 text-sm">
            You agree that you will be personally responsible for your use of
            the Service, and you agree to defend, indemnify and hold harmless
            Mozio and its officers, directors, employees, consultants,
            affiliates, subsidiaries and agents (collectively, the &quot;Mozio
            Entities&quot;) from and against any and all claims, liabilities,
            damages, losses and expenses, including reasonable attorneys&apos;
            and accounting fees and costs, arising out of or in any way
            connected with (i) your access to, use of or alleged use of the
            Service; (ii) your violation of the Terms or any representation,
            warranty, or agreements referenced herein, or any applicable law or
            regulation; (iii) your violation of any third party right, including
            without limitation any intellectual property right, publicity,
            confidentiality, property or privacy right; or (iv) any disputes or
            issues between you and any third party. We reserve the right, at our
            own expense, to assume the exclusive defense and control of any
            matter otherwise subject to indemnification by you, and in such
            case, you agree to cooperate with our defense of such claim.
          </p>
        </li>

        <li className="mb-4 text-lg">
          11. Disclaimers; No Warranties.
          <p className="mb-4 text-sm">
            SERVICE IS PROVIDED &quot;AS IS&quot; AND ON AN &quot;AS
            AVAILABLE&quot; BASIS, WITHOUT WARRANTY OR CONDITION OF ANY KIND,
            EITHER EXPRESS OR IMPLIED. THE MOZIO ENTITIES SPECIFICALLY (BUT
            WITHOUT LIMITATION) DISCLAIM (i) ANY IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT
            OR NON-INFRINGEMENT; (ii) ANY WARRANTIES ARISING OUT OF
            COURSE-OF-DEALING, USAGE, OR TRADE; (iii) ANY WARRANTIES THAT THE
            INFORMATION OR RESULTS PROVIDED IN, OR THAT MAY BE OBTAINED FROM USE
            OF, THE SERVICE WILL MEET YOUR REQUIREMENTS OR BE ACCURATE,
            RELIABLE, COMPLETE, OR UP-TO-DATE; AND (iv) ANY WARRANTIES
            WHATSOEVER REGARDING ANY PRODUCTS, SERVICES, INFORMATION OR OTHER
            MATERIAL ADVERTISED, MADE AVAILABLE, OR REFERRED TO YOU THROUGH THE
            SERVICE. YOU ASSUME ALL RISK FOR ALL DAMAGES, INCLUDING DAMAGE TO
            YOUR COMPUTER SYSTEM, MOBILE DEVICE OR LOSS OF DATA THAT MAY RESULT
            FROM YOUR USE OF OR ACCESS TO THE SERVICE. ANY CONTENT, MATERIALS,
            INFORMATION OR SOFTWARE DOWNLOADED, USED OR OTHERWISE OBTAINED
            THROUGH THE USE OF THE SERVICE IS DONE AT YOUR OWN DISCRETION AND
            RISK.
          </p>
          <p className="mb-4 text-sm">
            SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES
            IN SOME CIRCUMSTANCES. ACCORDINGLY, SOME OF THE ABOVE LIMITATIONS
            MAY NOT APPLY TO YOU.
          </p>
        </li>

        <li className="mb-4 text-lg">
          12. Limitation of Liability.
          <p className="mb-4 text-sm">
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, NEITHER THE MOZIO
            ENTITIES NOR ANY OTHER PARTY INVOLVED IN CREATING, PRODUCING,
            OPERATING OR DELIVERING THE SERVICE WILL BE LIABLE FOR ANY
            INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, WHETHER
            BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), STATUTE OR
            ANY OTHER LEGAL THEORY, WHETHER OR NOT THE MOZIO ENTITIES HAVE BEEN
            INFORMED OF THE POSSIBILITY OF SUCH DAMAGE WHERE SUCH DAMAGES RESULT
            FROM: (i) YOUR ACCESS TO OR USE OF, OR INABILITY TO ACCESS OR USE,
            THE SERVICE, OR (ii) ANY PURCHASE OF A THIRD PARTY PRODUCT OR
            SERVICE BASED ON INFORMATION CONTAINED IN THE MOZIO SERVICE. YOU
            SPECIFICALLY ACKNOWLEDGE THAT THE MOZIO ENTITIES ARE NOT LIABLE FOR
            THE DEFAMATORY, OFFENSIVE OR ILLEGAL CONDUCT OF OTHER USERS OR THIRD
            PARTIES AND THAT THE RISK OF INJURY FROM THE FOREGOING RESTS
            ENTIRELY WITH YOU. FURTHER, THE MOZIO ENTITIES WILL HAVE NO
            LIABILITY TO YOU OR TO ANY THIRD PARTY FOR ANY THIRD-PARTY CONTENT
            UPLOADED ONTO OR DOWNLOADED FROM THE SITE OR THROUGH THE SERVICE.
          </p>
          <p className="mb-4 text-sm">
            YOU AGREE THAT THE AGGREGATE LIABILITY OF THE MOZIO ENTITIES TO YOU
            FOR ANY AND ALL CLAIMS ARISING FROM OR RELATED TO THE USE OF THE
            SERVICE IS LIMITED TO THE GREATER OF (i) THE AMOUNTS YOU HAVE PAID
            TO MOZIO FOR ACCESS TO AND USE OF THE SERVICE GIVING RISE TO SUCH
            LIABILITY IN THE TWELVE (12) MONTHS PRIOR TO THE CLAIM OR (ii) $100.
            THE LIMITATIONS OF DAMAGES SET FORTH ABOVE ARE FUNDAMENTAL ELEMENTS
            OF THE BASIS OF THE BARGAIN BETWEEN MOZIO AND YOU.
          </p>
          <p className="mb-4 text-sm">
            SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OR EXCLUSION OF
            LIABILITY IN CERTAIN CIRCUMSTANCES. ACCORDINGLY, SOME OF THE ABOVE
            LIMITATIONS MAY NOT APPLY TO YOU.
          </p>
        </li>

        <li className="mb-4 text-lg">
          13. Dispute Resolution and Arbitration
          <ol type="1" className="mb-4 text-sm">
            <li className="mb-4 text-sm">
              13.1 Generally. In the interest of resolving disputes between you
              and Mozio in the most expedient and cost effective manner, you and
              Mozio agree that any and all disputes arising in connection with
              these Terms of the Service shall be resolved by binding
              arbitration. Arbitration is more informal than a lawsuit in court.
              Arbitration uses a neutral arbitrator instead of a judge or jury,
              may allow for more limited discovery than in court, and can be
              subject to very limited review by courts. Arbitrators can award
              the same damages and relief that a court can award. Our agreement
              to arbitrate disputes includes, but is not limited to all claims
              arising out of or relating to any aspect of these Terms, whether
              based in contract, tort, statute, fraud, misrepresentation or any
              other legal theory, and regardless of whether the claims arise
              during or after the termination of these Terms. You understand and
              agree that, by entering into these Terms, you and Mozio are each
              waiving the right to a trial by jury or to participate in a class
              action.
            </li>
            <li className="mb-4 text-sm">
              13.2 Exceptions. Notwithstanding subsection (15.1, we both agree
              that nothing herein shall be deemed to waive, preclude, or
              otherwise limit either of our right to (i) bring an individual
              action in small claims court, (ii) pursue enforcement actions
              through applicable federal, state, or local agencies where such
              actions are available, (iii) seek injunctive relief in a court of
              law, or (iv) to file suit in a court of law to address
              intellectual property infringement claims.
            </li>
            <li className="mb-4 text-sm">
              13.3 Arbitrator. Any arbitration between you and Mozio will be
              governed by the Commercial Dispute Resolution Procedures and the
              Supplementary Procedures for Consumer Related Disputes
              (collectively, &quot;AAA Rules&quot;) of the American Arbitration
              Association (&quot;AAA&quot;), as modified by these Terms, and
              will be administered by the AAA. The AAA Rules and filing forms
              are available online at www.adr.org, by calling the AAA at
              1-800-778-7879, or by contacting Mozio.
            </li>
            <li className="mb-4 text-sm">
              13.4 Notice; Process. A party who intends to seek arbitration must
              first send a written notice of the dispute to the other, by
              certified mail, Federal Express (signature required), or in the
              event that we do not have a physical address on file for you, we
              may send notice to you by electronic mail (&quot;Notice&quot;).
              Mozio&apos;s address for Notice is: [Mozio, Inc., 9450 SW Gemini
              Drive, Beaverton OR 97008, United States of America]. The Notice
              must (a) describe the nature and basis of the claim or dispute;
              and (b) set forth the specific relief sought (&quot;Demand&quot;).
              We agree to use good faith efforts to resolve the claim directly,
              but if we do not reach an agreement to do so within 30 days after
              the Notice is received, you or Mozio may commence an arbitration
              proceeding. During the arbitration, the amount of any settlement
              offer made by you or Mozio shall not be disclosed to the
              arbitrator until after the arbitrator makes a final decision and
              award, if any; provided that if our dispute is finally resolved
              through arbitration in your favor, Mozio shall pay you the greater
              of (i) the amount awarded by the arbitrator, if any, and (ii) the
              greatest amount offered by Mozio in settlement of the dispute
              prior to the arbitrator’s award.
            </li>
            <li className="mb-4 text-sm">
              13.5 Fees. Any arbitration hearings will take place at a location
              to be agreed upon in San Francisco, CA, provided that if the claim
              is for $10,000 or less, you may choose whether the arbitration
              will be conducted solely on the basis of documents submitted to
              the arbitrator, through a non-appearance based telephonic hearing,
              or by an in-person hearing as established by the AAA Rules. If the
              arbitrator finds that either the substance of your claim or the
              relief sought in the Demand is frivolous or brought for an
              improper purpose (as measured by the standards set forth in
              Federal Rule of Civil Procedure 11(b)), then the payment of all
              fees will be governed by the AAA Rules. In such case, you agree to
              reimburse Mozio for all monies previously disbursed by it that are
              otherwise your obligation to pay under the AAA Rules. Regardless
              of the manner in which the arbitration is conducted, the
              arbitrator shall issue a reasoned written decision sufficient to
              explain the essential findings and conclusions on which the
              decision and award, if any, are based. The arbitrator may make
              rulings and resolve disputes as to the payment and reimbursement
              of fees or expenses at any time during the proceeding and upon
              request from either party made within 14 days of the arbitrator’s
              ruling on the merits.
            </li>
            <li className="mb-4 text-sm">
              13.6 No class actions. YOU AND MOZIO AGREE THAT EACH MAY BRING
              CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY,
              AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR
              REPRESENTATIVE PROCEEDING. Further, unless both you and Mozio
              agree otherwise, the arbitrator may not consolidate more than one
              person’s claims, and may not otherwise preside over any form of a
              representative or class proceeding.
            </li>
            <li className="mb-4 text-sm">
              13.7 Modifications. In the event that Mozio makes any future
              change to this arbitration provision (other than a change to the
              Mozio&apos;s address for Notice), you may reject any such change
              by sending us written notice within 30 days of the change to
              Mozio&apos;s address for Notice, in which case your account with
              Mozio shall be immediately terminated and this arbitration
              provision, as in effect immediately prior to the amendments you
              reject shall survive.
            </li>
            <li className="mb-4 text-sm">
              13.8 Enforceability. If only Subsection 12.6 is found to be
              unenforceable or the entirety of this Section 12 is found to be
              unenforceable, then the entirety of this Section 12 shall be null
              and void and, in such case, the parties agree that the exclusive
              jurisdiction and venue described in Section 12 shall govern any
              action arising out of or related to these Terms.
            </li>
          </ol>
        </li>

        <li className="mb-4 text-lg">
          14. Refunds
          <ol type="1" className="mb-4 text-sm">
            <li className="mb-4 text-sm">
              14.1 Any refund requests must be made within 30 days of the trip
              date, to allow for timely investigation.
            </li>
            <li className="mb-4 text-sm">
              14.2 Refund requests will be subject to investigation which may
              take a minimum of 72 business hours to resolve. At the end of said
              investigation the person requesting a refund will be notified of
              its approval or rejection.
            </li>
            <li className="mb-4 text-sm">
              14.3. Evidence of the claim may be requested from the person
              demanding a refund. Failure to reply may result in the rejection
              of their refund request.
            </li>
            <li className="mb-4 text-sm">
              14.4 To facilitate a prompt investigation, any refund requests
              shall be submitted within 30 days of the trip date.
            </li>
            <li className="mb-4 text-sm">
              14.5. Refund requests are subject to a comprehensive
              investigation, with a minimum resolution period of 72 business
              hours. Following the conclusion of this inquiry, the individual
              initiating the refund request will be duly notified of its
              approval or rejection.
            </li>
            <li className="mb-4 text-sm">
              14.6 In the event of a refund request, the individual making the
              claim may be asked to provide evidence to support their request.
              Prompt response to such requests is crucial, as failure to reply
              within a reasonable timeframe may lead to the rejection of the
              refund request.
            </li>
            <li className="mb-4 text-sm">
              14.7 In situations where the service was utilized in accordance
              with its specifications, irrespective of the prevailing
              conditions, it&apos;s important to note that a complete refund
              will not be granted. A maximum of 20% of the ride&apos;s value,
              may be considered upon approval.
            </li>
          </ol>
        </li>

        <li className="mb-4 text-lg">
          15. Governing Law; Venue.
          <p className="mb-4 text-sm">
            These Terms, whether interpreted in a court of law or in
            arbitration, shall be governed by the laws of the State of
            California as they apply to agreements entered into and to be
            performed entirely within California by California residents, and
            without regard to conflict of law principles. To the extent that any
            lawsuit or court proceeding is permitted hereunder, you and Mozio
            agree to submit to the personal and exclusive jurisdiction of the
            state courts and federal courts located within the San Francisco,
            California for the purpose of litigating all such claims or
            disputes. We operate the Service from our offices in California, and
            we make no representations that information and materials included
            in the Service are appropriate or available for use in other
            locations. Access to the Service from any territory where the
            content is illegal is prohibited.
          </p>
        </li>

        <li className="mb-4 text-lg">
          16. General
          <p className="mb-4 text-sm">
            The Terms, together with the Privacy Policy and any other agreements
            expressly incorporated by reference herein, constitute the entire
            and exclusive understanding and agreement between you and Mozio
            regarding your use of and access to the Service, and except as
            expressly permitted above may only be amended by a written agreement
            signed by authorized representatives of the parties. You may not
            assign or transfer the Terms or your rights hereunder, in whole or
            in part, by operation of law or otherwise, without our prior written
            consent. We may assign the Terms at any time without notice. The
            failure to require performance of any provision shall not affect our
            right to require performance at any time thereafter, nor shall a
            waiver of any breach or default of the Terms constitute a waiver of
            any subsequent breach or default or a waiver of the provision
            itself. Use of paragraph headers in the Terms is for convenience
            only and shall not have any impact on the interpretation of
            particular provisions. In the event that any part of the Terms is
            held to be invalid or unenforceable, the unenforceable part shall be
            given effect to the greatest extent possible and the remaining parts
            will remain in full force and effect. Upon termination of the Terms,
            any provision which, by its nature or express terms should survive,
            will survive such termination or expiration, including, but not
            limited to, Section 5 with respect to the closing or termination of
            Mozio accounts and Sections 6 through 17.
          </p>
        </li>

        <li className="mb-4 text-lg">
          17. Contact Information.
          <p className="mb-4 text-sm">
            If you have any questions regarding Mozio, the Service, or the Terms
            please contact us at travel-extras@mozio.com.
          </p>
        </li>

        <li className="mb-4 text-lg">
          18. Service Modification and Cancellation
          <ol type="1" className="mb-4 text-sm">
            <li className="mb-4 text-sm">
              18.1 Reservations can be modified through the self-service portal
              made available to the booking party at the time of booking and on
              their confirmation email.
            </li>
            <li className="mb-4 text-sm">
              18.2 The booking party must guarantee the information recorded on
              their reservation is accurate.
            </li>
            <li className="mb-4 text-sm">
              18.3 Any and all modifications to the reservation details may
              result in an increase of the price of the reservation which must
              be assumed by the booking party and are subject to availability of
              the service.
            </li>
            <li className="mb-4 text-sm">
              18.4 Modifications are subject to the cancellation policy
              communicated for the reservation. Once the cancellation cut off
              has passed, any modification will not be possible and will never
              result in a refund of the value of the reservation or any type of
              compensation to the booking party and/or user.
            </li>
            <li className="mb-4 text-sm">
              18.5 The booking party is the sole responsible for processing
              modifications to the reservation in a timely manner.
            </li>
            <li className="mb-4 text-sm">
              18.6 Reservations can be canceled through the self-service portal
              made available to the booking party at the time of booking and on
              their confirmation email subject to the cancellation policy
              communicated at the time of booking.
            </li>
            <li className="mb-4 text-sm">
              18.7 Cancellation of a reservation outside the cancellation policy
              will not result in a refund in any case for the value of the ride
              nor the value of the feature.
            </li>
            <li className="mb-4 text-sm">
              18.8 Unless specified at the time of booking, cancellation will be
              in the form of a credit voucher or coupon code for the value paid
              for the reservation and valid for one year from the moment of
              cancellation to be redeemed by the booking party on the same URL
              originally used for booking.
            </li>
            <li className="mb-4 text-sm">
              18.9 The value of the refund will match the full amount paid for
              the reservation and not the full amount of the ride. Coupons and
              discounts applied will not be taken into consideration for the
              refunded amount.
            </li>
          </ol>
        </li>
      </ol>
    </main>
  );
};
